<template>
  <!-- table -->
  <xm-flex>
    <xm-flex-item>
      <xm-search-box>
        <el-select v-model="search.templateGroupId" placeholder="请选择类型" size="small" @change="searchData">
          <el-option v-for="item in selector.templateGroupList" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>
        <el-button size="small" type="primary" @click="add">新增模板</el-button>
      </xm-search-box>
    </xm-flex-item>
    <xm-flex-item><xm-total-count>{{`企业模板列表(${totalCount}条)`}}</xm-total-count></xm-flex-item>
    <xm-flex-item :flex="1">
      <xm-table-plus :query-data="queryData" ref="table">
        <el-table-column prop="id" label="ID" width="80"></el-table-column>
        <el-table-column prop="templateGroup.name" label="类型" width="150"></el-table-column>
        <el-table-column prop="name" label="名称"></el-table-column>
        <el-table-column label="商品页签">
          <template #default="scope">
            <el-tag type="primary" size="small" v-if="scope.row.showGoodsTab">显示</el-tag>
            <el-tag type="info" size="small" v-else>隐藏</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="goodsName" label="页签名"></el-table-column>
        <el-table-column prop="goodsIcon" label="页签图标"></el-table-column>
        <el-table-column label="示例" width="92">
          <template #default="scope">
            <el-image style="width: 70px; height: 70px" :src="scope.row.sampleImage" fit="contain" :preview-src-list="[scope.row.sampleImage]" :initial-index="1"></el-image>
          </template>
        </el-table-column>
        <el-table-column prop="cardPosterTemplate.name" label="名片模板" width="100"></el-table-column>
        <el-table-column prop="descGroupTemplate.name" label="图文组合模板" width="120"></el-table-column>
        <el-table-column label="状态" width="70">
          <template #default="scope">
            <el-tag type="primary" size="small" v-if="scope.row.flag === 1">显示</el-tag>
            <el-tag type="info" size="small" v-else>隐藏</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="210">
          <template #default="scope">
            <el-button type="text" size="small" @click="modify(scope.row)">修改</el-button>
            <el-button type="text" size="small" @click="setFlag(scope.row.id, scope.row.flag)">{{scope.row.flag===1?'隐藏':'显示'}}</el-button>
            <el-dropdown @command="handleCommand">
              <el-button type="text" size="small" class="el-dropdown-link">更多</el-button>
              <template #dropdown>
                <el-dropdown-menu>
                  <el-dropdown-item :command="{name: 'move', id: scope.row.id, action: 'up'}" v-if="!scope.row._isFirst">上移</el-dropdown-item>
                  <el-dropdown-item :command="{name: 'move', id: scope.row.id, action: 'down'}" v-if="!scope.row._isLast">下移</el-dropdown-item>
                  <el-dropdown-item :command="{name: 'move', id: scope.row.id, action: 'top'}" v-if="!scope.row._isFirst">置顶</el-dropdown-item>
                  <el-dropdown-item :command="{name: 'move', id: scope.row.id, action: 'bottom'}" v-if="!scope.row._isLast">置底</el-dropdown-item>
                  <el-dropdown-item :command="{name: 'clear', id: scope.row.id}">删除</el-dropdown-item>
                </el-dropdown-menu>
              </template>
            </el-dropdown>
          </template>
        </el-table-column>
      </xm-table-plus>
    </xm-flex-item>
  </xm-flex>
  <!-- dialog -->
  <el-dialog v-model="dialog.visible" :title="dialog.title" destroy-on-close>
    <el-form ref="ruleForm" :model="dialog.data" label-width="auto">
      <!-- 名称 -->
      <el-form-item label="名称" prop="name" :rules="[
        {required:true, message: '名称不能为空',trigger: 'blur'}
      ]">
        <el-input v-model="dialog.data.name" size="small" maxlength="128" clearable></el-input>
      </el-form-item>
      <!-- 类型 -->
      <el-form-item label="类型" prop="templateGroupId" :rules="[
        {required:true, message: '类型不能为空',trigger: 'blur'}
      ]">
        <el-select v-model="dialog.data.templateGroupId" placeholder="请选择类型" size="small" clearable>
          <el-option v-for="item in selector.templateGroupList" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <!-- 是否显示商品页签 -->
      <el-form-item label="显示商品页签" prop="showGoodsTab">
        <el-select v-model="dialog.data.showGoodsTab" placeholder="请选择是否显示商品页签" size="small" clearable>
          <el-option label="是" :value="true"></el-option>
          <el-option label="否" :value="false"></el-option>
        </el-select>
      </el-form-item>
      <!-- 页签名 -->
      <el-form-item label="页签名" prop="goodsName" :rules="[
        {required:true, message: '页签名不能为空',trigger: 'blur'}
      ]" v-if="dialog.data.showGoodsTab">
        <el-input v-model="dialog.data.goodsName" size="small" maxlength="16" clearable></el-input>
      </el-form-item>
      <!-- 页签图标 -->
      <el-form-item label="页签图标" prop="goodsIcon" :rules="[
        {required:true, message: '页签图标不能为空',trigger: 'blur'}
      ]" v-if="dialog.data.showGoodsTab">
        <el-select v-model="dialog.data.goodsIcon" placeholder="请选择页签图标" size="small" clearable>
          <el-option label="商品" value="icongoods"></el-option>
          <el-option label="课程" value="iconbook"></el-option>
          <el-option label="产品" value="iconproduct"></el-option>
          <el-option label="医疗" value="iconhospital"></el-option>
        </el-select>
      </el-form-item>
      <!-- 名片模板 -->
      <el-form-item label="名片模板" prop="cardPosterTemplateId" :rules="[
        {required:true, message: '名片模板不能为空',trigger: 'blur'}
      ]">
        <el-select v-model="dialog.data.cardPosterTemplateId" placeholder="请选择名片模板" size="small" clearable>
          <el-option v-for="item in selector.cardPosterTemplateList" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <!-- 图文组合模板 -->
      <el-form-item label="图文组合模板" prop="descGroupTemplateId" :rules="[
        {required:true, message: '图文组合模板不能为空',trigger: 'blur'}
      ]">
        <el-select v-model="dialog.data.descGroupTemplateId" placeholder="请选择图文组合模板" size="small" clearable>
          <el-option v-for="item in selector.descGroupTemplateList" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <!-- 封面图片 -->
      <el-form-item label="封面图" prop="sampleImage" :rules="[
        {required: !dialog.data.institutionTemplateId, message: '封面图不能为空', trigger: 'blur'}
      ]">
        <el-upload action="" :http-request="uploadImage" :on-exceed="exceedImage" :limit="1" list-type="picture">
          <el-button size="small" type="default">上传图片</el-button>
        </el-upload>
      </el-form-item>
    </el-form>
    <template #footer>
      <el-button @click="dialog.visible = false" size="small">取消</el-button>
      <el-button type="primary" @click="confirm" size="small">确定</el-button>
    </template>
  </el-dialog>
</template>
<script>
import { ElButton, ElDialog, ElSelect, ElOption, ElTableColumn, ElForm, ElFormItem, ElInput, ElDropdown, ElDropdownItem, ElDropdownMenu, ElUpload, ElImage, ElTag } from 'element-plus'
import axios from '@/common/utils/axios'
import { onMounted, reactive, ref } from 'vue'
import type from '@/common/utils/type'
import upload from '@/common/utils/upload'

function table () {
  const search = reactive({
    templateGroupId: ''
  })
  const selector = reactive({
    templateGroupList: [],
    cardPosterTemplateList: [],
    descGroupTemplateList: []
  })
  /**
     * 表单信息
     */
  const table = ref(null)
  const totalCount = ref(0)
  /**
     * 查询表单列表
     */
  const queryData = (page, pageSize) => {
    return new Promise((resolve) => {
      axios('/manager/institution/template/list', {
        templateGroupId: search.templateGroupId,
        page,
        pageSize
      })
        .then(res => {
          totalCount.value = res.totalCount
          table.value.judgePosition(res.institutionTemplateList, res.totalCount)
          resolve({
            list: res.institutionTemplateList,
            totalCount: res.totalCount
          })
        }).catch(_ => { })
    })
  }
  /**
   * 搜索模板
   */
  const searchData = () => {
    table.value.reload()
  }
  /**
     * 查询枚举--模板类型
     */
  const queryType = () => {
    return new Promise((resolve) => {
      axios('/manager/template/group/list/all', { type: type().templateGroupType.institution })
        .then(res => {
          res.templateGroupList.forEach(item => {
            selector.templateGroupList.push(item)
          })
          search.templateGroupId = res.templateGroupList[0].id
          resolve()
        }).catch(_ => { })
      axios('/manager/card/poster/template/list/all', {})
        .then(res => {
          selector.cardPosterTemplateList = res.cardPosterTemplateList
        }).catch(_ => { })
      axios('/manager/desc/group/template/list/all', {})
        .then(res => {
          selector.descGroupTemplateList = res.descGroupTemplateList
        }).catch(_ => { })
    })
  }
  onMounted(async () => {
    await queryType()
    table.value.reload()
  })

  return {
    search,
    selector,
    table,
    queryData,
    totalCount,
    searchData
  }
}

function dialog () {
  const ruleForm = ref(null)
  const dialog = reactive({
    visible: false,
    title: '',
    data: {}
  })
  return {
    ruleForm,
    dialog
  }
}

function operation (t, d, dr) {
  /**
     * 新增
     */
  const add = () => {
    d.dialog.visible = true
    d.dialog.title = '新增模板'
    d.dialog.data = {
      institutionTemplateId: '',
      templateGroupId: t.search.templateGroupId,
      name: '',
      showGoodsTab: true,
      goodsName: '',
      goodsIcon: '',
      cardPosterTemplateId: '',
      descGroupTemplateId: ''
    }
  }
  /**
     * 修改
     */
  const modify = (row) => {
    d.dialog.visible = true
    d.dialog.title = '修改模板'
    d.dialog.data = {
      institutionTemplateId: row.id,
      templateGroupId: row.templateGroup.id,
      name: row.name,
      showGoodsTab: row.showGoodsTab,
      goodsName: row.goodsName,
      goodsIcon: row.goodsIcon,
      cardPosterTemplateId: row.cardPosterTemplate.id,
      descGroupTemplateId: row.descGroupTemplate.id,
      sampleImage: row.sampleImage
    }
  }
  /**
   * 保存企业模板
   */
  const confirm = () => {
    d.ruleForm.value.validate(valid => {
      if (!valid) {
        return
      }
      submit()
    })
  }
  const submit = () => {
    axios('/manager/institution/template/save', d.dialog.data)
      .then(res => {
        window.$message({
          message: '操作成功',
          type: 'success'
        })
        d.dialog.visible = false
        t.table.value.reloadCurrent()
      }).catch(_ => { })
  }
  /**
   * 更改状态
   */
  const setFlag = (id, flag) => {
    axios('/manager/institution/template/flag/set', {
      institutionTemplateId: id,
      flag: flag === 1 ? 0 : 1
    }).then(res => {
      window.$message({
        message: '操作成功',
        type: 'success'
      })
      t.table.value.reloadCurrent()
    })
  }
  /**
     * 指令列表
     */
  const handleCommand = (command) => {
    commandList[command.name](command.id, command.action)
  }
  const commandList = {
    clear: (id) => { // 删除
      window.$confirm('是否确认删除').then(() => {
        del(id)
      }).catch(_ => { })
    },
    move: (id, action) => {
      axios('/manager/institution/template/move', {
        institutionTemplateId: id,
        move: action
      }).then(res => {
        window.$message({
          message: '操作成功',
          type: 'success'
        })
        t.table.value.reload()
      })
    }
  }
  const del = (id) => {
    axios('/manager/institution/template/del', {
      institutionTemplateId: id
    })
      .then(res => {
        window.$message({
          message: '操作成功',
          type: 'success'
        })
        t.table.value.reloadCurrent()
      }).catch(_ => { })
  }
  /**
   * 上传图片
   */
  const uploadImage = ({ file }) => {
    upload(file, '0', (url) => {
      d.dialog.data.sampleImage = url
    })
  }
  /**
   * 超出数量提示
   */
  const exceedImage = () => {
    window.$message({
      message: '图片超出数量，请删除后上传',
      type: 'error'
    })
  }
  return {
    add,
    modify,
    confirm,
    setFlag,
    handleCommand,
    uploadImage,
    exceedImage
  }
}

export default {
  components: { ElButton, ElDialog, ElSelect, ElOption, ElTableColumn, ElForm, ElFormItem, ElInput, ElDropdown, ElDropdownItem, ElDropdownMenu, ElUpload, ElImage, ElTag },

  setup () {
    const t = table()
    const d = dialog()
    const o = operation(t, d)
    return {
      ...t,
      ...d,
      ...o
    }
  }
}
</script>
<style lang="scss" scoped>
.button-group {
  text-align: right;
}
:deep .tox-tinymce{
  height: calc(100% - 20px) !important;
}
.el-dropdown .el-button {
  margin-left: 10px;
}
</style>
